var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57061 7.43332L0.245605 4.10832L1.07686 3.27707L3.57061 5.77082L8.92269 0.418732L9.75394 1.24998L3.57061 7.43332Z",
    fill: "#5CCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck3);
export default __webpack_public_path__ + "static/media/check-3.af2516ea.svg";
export { ForwardRef as ReactComponent };